import jwtAuthAxios from "../auth/jwtAuth";
import { setAuthBackendDomain, setBackendDomain } from "./management";

export const getProduct = async (url, customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/products/get?url=${url}&customerId=${customerId}`,
  );
  return data.product;
};

export const getProducts = async (customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/products/list?customerId=${customerId}`,
  );
  return data.response;
};

export const addProduct = async (customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/products/add", { customerId });
  return data.url;
};

export const updateProduct = async (product) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/products/update", product);
  return data;
};

export const updateProductCrossSell = async (productId, crossSellData) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.put(
    `/api/v1/products/cross-sell/${productId}`,
    crossSellData,
  );
  return data?.data;
};

export const copyProduct = async (url) => {
  setAuthBackendDomain(jwtAuthAxios);
  const bodyFormData = new FormData();
  bodyFormData.append("url", url);
  const { data } = await jwtAuthAxios.post("/presentation/copy", bodyFormData);
  return data;
};

export const refreshPresentation = async (url) => {
  setAuthBackendDomain(jwtAuthAxios);
  const bodyFormData = new FormData();
  bodyFormData.append("url", url);
  const { data } = await jwtAuthAxios.post(
    "/presentation/refresh",
    bodyFormData,
  );
  return data;
};

export const deleteProduct = async (url, customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(
    `/products/delete?url=${url}&customerId=${customerId}`,
  );
  return data;
};
